import Vue from 'vue'
import Vuex from 'vuex'
import createPersistedState from 'vuex-persistedstate'
import axios from 'axios'
import router from '@/router/index.js'
import http from '@/http/http.js'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    username: null,
    buymaId: null,
    token: null
  },
  getters: {
    getUsername (state) {
      return state.username
    },
    getBuymaId (state) {
      return state.buymaId
    },
    getToken (state) {
      return state.token
    }
  },
  mutations: {
    login (state, value) {
      state.username = value.username
      state.buymaId = value.buymaId
      state.token = value.token
    },
    logout (state) {
      state.username = null
      state.buymaId = null
      state.token = null
    },
    update (state, value) {
      state.token = value
    }
  },
  actions: {
    login (context, request) {
      var params = new URLSearchParams()
      params.append('loginId', request.loginId)
      params.append('password', request.password)
      axios.post(`${process.env.VUE_APP_API_ORIGIN}/user/authenticate`, params).then(response => {
        const token = response.headers.authorization
        if (token != null && token !== '') {
          const buymaId = response.data.buymaId
          context.commit('login', { username: request.loginId, buymaId: buymaId, token: token })
        }
      })
    },
    logout (context) {
      context.commit('logout')
      router.push('/login')
    },
    check (context) {
      return new Promise((resolve, reject) => {
        http.get(`${process.env.VUE_APP_API_ORIGIN}/user/name`).then(response => {
          if (response.data === context.state.username) {
            resolve()
          } else {
            context.commit('logout')
            reject(response.data)
          }
        }).catch((e) => {
          context.commit('logout')
          reject(e)
        })
      })
    },
    update (context, value) {
      context.commit('update', value)
    }
  },
  plugins: [createPersistedState({
    key: 'BUYMEISTER',
    storage: window.localStorage
  })]
})
